module.exports = __webpack_public_path__ + "static/media/somewheregood.0fe105e7.gif";